"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeQuickQuoteAddressWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var InfoModal_1 = require("../../../components/modals/InfoModal");
var commonFunctions_1 = require("../../../commonFunctions");
var AnnualHomeQuickQuoteAddressWidget = /** @class */ (function (_super) {
    __extends(AnnualHomeQuickQuoteAddressWidget, _super);
    function AnnualHomeQuickQuoteAddressWidget(props) {
        return _super.call(this, props) || this;
    }
    AnnualHomeQuickQuoteAddressWidget.prototype.render = function () {
        var address = (0, commonFunctions_1.getAddressLine1WithPostcode)(this.props.interaction.realEstate[0].address);
        return ((0, jsx_runtime_1.jsx)("div", { className: "section-panel annual-home-mta page-contents-inner mt-0", children: (0, jsx_runtime_1.jsxs)("div", { className: "section", children: [(0, jsx_runtime_1.jsx)("img", { className: "home-image grid-row-1-2", src: "/Allianz/img/home-icon.svg", alt: "Home icon" }), (0, jsx_runtime_1.jsxs)("div", { className: "mb-0 section-heading", children: [(0, jsx_runtime_1.jsx)("span", { children: "Insured address" }), this.renderInfoModal()] }), (0, jsx_runtime_1.jsx)("div", { children: address })] }) }));
    };
    AnnualHomeQuickQuoteAddressWidget.prototype.renderInfoModal = function () {
        return ((0, jsx_runtime_1.jsx)(InfoModal_1.InfoModal, { title: "Insured address", className: "d-inline align-middle", children: (0, jsx_runtime_1.jsx)("p", { children: "All policies under the same account need to have the same property address. If you wish to insure a different property than the one listed below please get a quote with a different email address." }) }));
    };
    return AnnualHomeQuickQuoteAddressWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomeQuickQuoteAddressWidget = AnnualHomeQuickQuoteAddressWidget;
//# sourceMappingURL=AnnualHomeQuickQuoteAddressWidget.js.map